import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-theme-seven',
  templateUrl: './theme-seven.component.html',
  styleUrls: ['./theme-seven.component.css']
})
export class ThemeSevenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
